import Storage from '@aws-amplify/storage';
import awsExportsOverriden from '../aws-exports-overriden';

Storage.configure(awsExportsOverriden);

type Level = 'public' | 'protected' | 'private';

interface UploadOptions {
  prefix: string;
  level: Level;
}

export async function uploadFile(
  identityId: string,
  file: File,
  { prefix, level = 'private' }: UploadOptions,
) {
  const s3Object = {
    key: `${prefix}${file.name}`,
    pathPrefix: `${level}/${identityId}`,
    bucket: awsExportsOverriden.aws_user_files_s3_bucket,
    region: awsExportsOverriden.aws_user_files_s3_bucket_region,
  };
  await Storage.put(s3Object.key, file, {
    level,
    contentType: file.type,
    progressCallback(progress: { loaded: number, total: number }) {
      // TODO implement progress bar
      console.log(`Uploaded: ${progress.loaded}/${progress.total}`);
    },
  });
  return s3Object;
}

export function getDownloadUrl(key: string, { level = 'private' }: { level: Level }) {
  return Storage.get(key, { level, download: false })
    .then((data) => (typeof data === 'string' ? data : null));
}
